const stateData = [
  {
    id: "1",
    name: "JAMMU AND KASHMIR",
  },
  {
    id: "2",
    name: "HIMACHAL PRADESH",
  },
  {
    id: "3",
    name: "PUNJAB",
  },
  {
    id: "4",
    name: "CHANDIGARH",
  },
  {
    id: "5",
    name: "UTTARAKHAND",
  },
  {
    id: "6",
    name: "HARYANA",
  },
  {
    id: "7",
    name: "DELHI",
  },
  {
    id: "8",
    name: "RAJASTHAN",
  },
  {
    id: "9",
    name: "UTTAR PRADESH",
  },
  {
    id: "10",
    name: "BIHAR",
  },
  {
    id: "11",
    name: "SIKKIM",
  },
  {
    id: "12",
    name: "ARUNACHAL PRADESH",
  },
  {
    id: "13",
    name: "NAGALAND",
  },
  {
    id: "14",
    name: "MANIPUR",
  },
  {
    id: "15",
    name: "MIZORAM",
  },
  {
    id: "16",
    name: "TRIPURA",
  },
  {
    id: "17",
    name: "MEGHALAYA",
  },
  {
    id: "18",
    name: "ASSAM",
  },
  {
    id: "19",
    name: "WEST BENGAL",
  },
  {
    id: "20",
    name: "JHARKHAND",
  },
  {
    id: "21",
    name: "ODISHA",
  },
  {
    id: "22",
    name: "CHHATTISGARH",
  },
  {
    id: "23",
    name: "MADHYA PRADESH",
  },
  {
    id: "24",
    name: "GUJARAT",
  },
  {
    id: "25",
    name: "DAMAN DIU AND DADRA NAGAR HAVELI",
  },
  // {
  //   id: "26",
  //   name: "DADRA AND NAGAR HAVELI",
  // },
  {
    id: "27",
    name: "MAHARASHTRA",
  },
  {
    id: "28",
    name: "TELANGANA",
  },
  {
    id: "29",
    name: "ANDHRA PRADESH",
  },
  {
    id: "30",
    name: "KARNATAKA",
  },
  {
    id: "31",
    name: "GOA",
  },
  {
    id: "32",
    name: "KERALA",
  },
  {
    id: "33",
    name: "TAMIL NADU",
  },
  {
    id: "34",
    name: "PUDUCHERRY",
  },
  {
    id: "35",
    name: "ANDAMAN AND NICOBAR ISLANDS",
  },
  {
    id: "37",
    name: "LADAKH",
  },
];

export default stateData;
